import { render, staticRenderFns } from "./SupplierEditTemplate.vue?vue&type=template&id=1a365ac8&"
import script from "./SupplierEditTemplate.vue?vue&type=script&lang=js&"
export * from "./SupplierEditTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a365ac8')) {
      api.createRecord('1a365ac8', component.options)
    } else {
      api.reload('1a365ac8', component.options)
    }
    module.hot.accept("./SupplierEditTemplate.vue?vue&type=template&id=1a365ac8&", function () {
      api.rerender('1a365ac8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/requests/editPages/SupplierEditTemplate.vue"
export default component.exports